import Button from "@mui/material/Button";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import PropTypes from "prop-types";
import { useWindowSize } from "@uidotdev/usehooks";
import { Box } from "@mui/material";

export const SendButton = ({ title, style = {}, onClick, disabled = false }) => {
  const { width } = useWindowSize();

  return (
    <Button
      variant="contained"
      onClick={onClick}
      disabled={disabled} // 👈 thêm disabled
      sx={{
        borderRadius: "999px",
        padding: "10px 24px",
        backgroundColor: disabled ? "#a0a0a0" : "#293990", 
        color: "#fff",
        width: width < 639 ? "100%" : "auto",
        fontSize: "16px",
        fontWeight: 600,
        textTransform: "none",
        display: "flex",
        alignItems: "center",
        gap: "12px",
        cursor: disabled ? "not-allowed" : "pointer", 
        "&:hover": {
          backgroundColor: disabled ? "#a0a0a0" : "#0f1157",
        },
        ...style,
      }}
    >
      {title}
      <Box
        sx={{
          backgroundColor: "#fff",
          borderRadius: "50%",
          width: "28px",
          height: "28px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <ArrowForwardIosIcon sx={{ fontSize: "16px", color: "#151686" }} />
      </Box>
    </Button>
  );
};

SendButton.propTypes = {
  title: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
  disabled: PropTypes.bool, 
};
